module.exports = __webpack_public_path__ + "fbea12e475c3491524b780f5a9a2f312.svg";